import apiClient from "./axios"

export const getLeaveTypes = async (params = {}) => {
  const { data } = await apiClient.get("/leave-types", { params })
  return data
}

export const createLeaveType = async payload => {
  const { data } = await apiClient.post("/leave-types", payload)
  return data
}

export const editLeaveType = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/leave-types/${id}`, payload)
  return data
}

export const deleteLeaveType = async id => {
  const { data } = await apiClient.delete(`/leave-types/${id}`)
  return data
}

export const restoreLeaveType = async id => {
  const { data } = await apiClient.post(`/leave-types/${id}/restore`)
  return data
}

export const getHolidays = async (params = {}) => {
  const { data } = await apiClient.get("/holidays", { params })
  return data
}

export const createHoliday = async payload => {
  const { data } = await apiClient.post("/holidays", payload)
  return data
}

export const editHoliday = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/holidays/${id}`, payload)
  return data
}

export const deleteHoliday = async id => {
  const { data } = await apiClient.delete(`/holidays/${id}`)
  return data
}

export const getLeaveRequests = async (params = {}) => {
  const { data } = await apiClient.get("/leave-requests", { params })
  return data
}

export const getMyLeaveRequests = async (params = {}) => {
  const { data } = await apiClient.get("/leave-requests/my-requests", { params })
  return data
}

export const createLeaveRequest = async payload => {
  const { data } = await apiClient.post("/leave-requests", payload)
  return data
}

export const approveLeaveRequest = async ({ id, action_note }) => {
  const { data } = await apiClient.post(`/leave-requests/${id}/approve`, { action_note })
  return data
}

export const rejectLeaveRequest = async ({ id, action_note }) => {
  const { data } = await apiClient.post(`/leave-requests/${id}/reject`, { action_note })
  return data
}

export const cancelLeaveRequest = async id => {
  const { data } = await apiClient.post(`/leave-requests/${id}/cancel`)
  return data
}

export const getMyBalances = async (params = {}) => {
  const { data } = await apiClient.get("/leave-requests/my-balances", { params })
  return data
}

export const updateLeaveBalance = async payload => {
  const { data } = await apiClient.put("/leave-requests/balances", payload)
  return data
}